var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.9 48.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #b8b7b7;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.69,
    y: 8.82,
    width: 30.34,
    height: 30.34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.4,39.08c-1.88.19-3.76.01-5.63-.53-.01,0-.03,0-.04-.01-.79-.23-1.56-.51-2.31-.85-1.27-.57-2.46-1.31-3.51-2.22-1.04-.9-1.95-1.96-2.69-3.13-.8-1.25-1.41-2.62-1.86-4.03-.65-2-.83-4.1-.56-6.18.11-.84.29-1.69.54-2.51.22-.74.5-1.46.83-2.16.66-1.37,1.53-2.64,2.56-3.75,1.03-1.11,2.22-2.06,3.53-2.82,1.31-.77,2.73-1.34,4.21-1.69,1.5-.36,3.06-.47,4.6-.34.33.03.66.07.99.12,6.95,1.07,12.13,6.49,12.88,13.47.79,7.27-3.88,14.14-10.92,16.12-.87.24-1.74.41-2.62.5h0ZM29.87,37.04c7.2,0,13.04-5.85,13.03-13.05,0-7.18-5.82-13-13-13.02-7.21-.01-13.05,5.82-13.06,13.02,0,7.2,5.83,13.05,13.03,13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.59,16.4c1.03-.02,1.91.16,2.72.62,1.5.86,2.02,2.49,1.3,4.06-.4.88-1.04,1.58-1.8,2.15-.83.63-1.29,1.39-1.23,2.47.03.62-.28.87-.97.92-.83.05-1.2-.16-1.26-.8-.15-1.44.21-2.69,1.4-3.63.45-.35.93-.67,1.28-1.13.8-1.04.37-2.16-.93-2.36-.93-.14-1.75.04-2.31.92-.4.63-.82.73-1.4.44-.51-.25-.73-.78-.57-1.4.25-.94.92-1.49,1.75-1.87.67-.3,1.39-.43,2.02-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.95,29.61c-.03.83-.76,1.52-1.59,1.48-.8-.04-1.47-.75-1.45-1.56.02-.84.73-1.53,1.56-1.5.84.03,1.5.74,1.47,1.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.76e1ff75d2ed195a2a068320656a0db2.svg";
export { ForwardRef as ReactComponent };